import {Component, OnInit} from '@angular/core';
import {TeBlueprintObjectBaseComponent} from "../te-blueprint-object-base.component";
import {ActivatedRoute} from "@angular/router";
import {ConfirmationService} from "primeng/api";
import {MvsCoreService} from "../../../../../../../core/shared/service/mvs-core.service";
import {MvsMessageService} from "../../../../../../../core/shared/service/message/mvs-message.service";
import {ObserverService} from "../../../../../../../core/shared/object/service/observer.service";

@Component({
    selector: 'te-blueprint-object-component-side',
    templateUrl: 'te-blueprint-object-side.component.html',
    standalone: false
})
export class TeBlueprintObjectSideComponent extends TeBlueprintObjectBaseComponent implements OnInit {

    constructor(
        protected route: ActivatedRoute,
        protected coreService: MvsCoreService,
        protected messageService: MvsMessageService,
        protected confirmationService: ConfirmationService,
        protected observerService: ObserverService) {
        super(route, coreService, messageService, confirmationService, observerService);
    }

    ngOnInit() {
        super.ngOnInit();
    }

    loadNavigationItems() {
        this.navigationItems = [
            {
                label: 'te.TeTemplateBlueprint',
                action: 'te.TeTemplateBlueprint',
                icon: 'fa-regular fa-blueprint text-xl',
                tooltip: 'Blueprint',
                toggleable: false,
                default: true
            },
            {
                label: 'te.TeTemplateBlueprintVariable',
                action: 'te.TeTemplateBlueprintVariable',
                icon: 'fa-solid fa-brackets-curly text-xl',
                tooltip: 'Variablen',
                toggleable: false,
                default: false
            },
            {
                label: 'te.TeTemplateBlueprintArtefact',
                action: 'te.TeTemplateBlueprintArtefact',
                icon: 'fa-solid fa-file-code text-xl',
                tooltip: 'Artefakte',
                toggleable: false,
                default: false
            }
        ];
    }
}
